/**
 * Tournois — règles de gestion PURES, lues par le serveur (`src/api/tournaments.ts`) ET par l'écran
 * (`TournamentsView`). Aucune dépendance serveur : importable côté client. Le compte de la requête
 * (`tournamentAccountFor`, qui lit la base) reste dans `tournament-access.ts`, qui ré-exporte ceci.
 */
// CSL retiré : fermé partout dans Pilot tant que ses droits ne sont pas arbitrés (encadrantRoleFor("CSL") = null).
export const ORGANIZER_PROFILES = ["ORG", "COO", "ADM", "MNG"];
/** Internes Kestio : peuvent agir sur le compte choisi dans la barre de Pilot (`accountId`). */
export const PILOT_ACCOUNT_PICKERS = ["ADM", "COO"];

/**
 * Qui GÈRE ce tournoi (modifier, supprimer, gérer les participants, démarrer) ? RÈGLE UNIQUE, lue
 * par le serveur (`src/api/tournaments.ts`, chaque route d'écriture) ET par l'écran (drapeaux
 * `isOrganizer` du détail et `canManage` de la liste) — décisions de Valérie du 30/09/2026 :
 *   - l'ORG garde la main sur TOUS les tournois de son compte, quel qu'en soit l'auteur ;
 *   - le MNG seulement sur les SIENS (auteur) ;
 *   - l'ADM et le COO sur le compte choisi dans la barre de Pilot (`tournamentAccountFor`,
 *     `PILOT_ACCOUNT_PICKERS`) : le COO gère les tournois comme l'ADM (création, modification,
 *     suppression, participants, démarrage) ;
 *   - CSL, RH, GES, BNF : jamais (un CSL auteur d'un tournoi ancien n'a plus la main).
 * Le compte du tournoi est vérifié par l'appelant (404 hors du compte de la requête).
 */
export function canOrganizeTournament(user: { id: string; profileType: string }, createdBy: string | null): boolean {
  if (!ORGANIZER_PROFILES.includes(user.profileType)) return false;
  if (user.profileType === "MNG") return createdBy != null && createdBy === user.id;
  return true; // ORG (son compte), ADM / COO (compte choisi)
}

/**
 * Un organisateur peut-il ajouter OU retirer cette personne d'un tournoi ? Le MNG n'agit que dans
 * son sous-arbre (lui compris) — pour l'ajout comme pour le retrait (décision du 30/09/2026).
 * `mngSubtree` : `getUserDescendants(user.id, { includeSelf: true })` côté serveur ; côté écran,
 * la liste des collaborateurs servie au MNG, qui est exactement ce sous-arbre.
 */
export function canManageTournamentParticipant(
  organizer: { profileType: string },
  targetUserId: string,
  mngSubtree: readonly string[] | null | undefined,
): boolean {
  if (organizer.profileType !== "MNG") return true;
  return !!mngSubtree && mngSubtree.includes(targetUserId);
}
